module.exports = __webpack_public_path__ + "img/no_rentals.c94261df.svg";